module.exports =
  require:
    ngModel: '^ngModel'
  template: require('./index.pug')()
  controller: require('./index.ctrl')
